export default "__VITE_ASSET__df578f0e__"